import { useEffect } from 'react';
// Redux
import { useAppDispatch } from 'app/hooks/useStore';
// Actions
import { BillingInvoicesActions } from 'app/store/BillingInvoices/BillingInvoices.slice';
// Mui
import { Box } from '@mui/material';
// 
import BillingInvoicesFilter from './BillingInvoicesFilter';
import BillingInvoicesBatchPayment from './BillingInvoicesBatchPayment';
import BillingInvoicesList from './InvoicesList';
import InvoicesSummary from './InvoicesSummary';
// Context
import InvoiceColumnsProvider from './InvoiceColumns.context';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

export default function InvoicesTabContent(){
  // Dispatch
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(MixpanelActions.handleBillingInvoicesView());
    return () => {
      dispatch(BillingInvoicesActions.resetState());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ height: '100%' }}>
      <InvoicesSummary />
      <Box sx={{ height: 'calc(100% - 64px)', display: 'flex' }}>
        <BillingInvoicesFilter />
        <Box sx={{ flexGrow: 1, p: 4, display: 'flex', flexDirection: 'column' }}>
          <BillingInvoicesBatchPayment />
          <InvoiceColumnsProvider>
            <BillingInvoicesList />
          </InvoiceColumnsProvider>
        </Box>
      </Box>
    </Box>
  )
};
